import React from 'react';
import { observer } from 'mobx-react';
import {
	BarChart,
	CarrierCbmChart,
	GridViewModal,
	ListPanel,
	ShipByDateChart,
	StatusCard,
} from 'modules/dashboard/components';

const METRICS = [
	{ key: 'onHold', label: 'On Hold', mod: 'warning' },
	{ key: 'late', label: 'Late Shipments', mod: 'danger' },
	{ key: 'prime', label: 'Prime', mod: 'info' },
];

const DashboardTemplate = observer(({ viewStore }) => {
	const {
		showWarehouses,
		showSellers,
		loading,
		error,
		activeMetric,
		onHoldCount,
		lateCount,
		primeCount,
		warehouseLabel,
		sellerLabel,
		chartData,
		selectedWarehouseName,
		totals,
		activeStatus,
		statusKeys,
		warehouseItems,
		selectedWarehouse,
		sellerItems,
		selectedSeller,
		shipmentTypeItems,
		selectedShipmentType,
		shipByDateRows,
		selectedDate,
		carrierCbm,
		gridViewOpen,
		completedLoading,
		completedPct,
	} = viewStore;

	const metricCounts = { onHold: onHoldCount, late: lateCount, prime: primeCount };

	return (
		<section className="layout__main__body dashboard-page">
			<div className="dashboard-page__toolbar">
				<button
					className={`header__grid-btn ${gridViewOpen ? 'header__grid-btn--active' : ''}`}
					onClick={() => (gridViewOpen ? viewStore.closeGridView() : viewStore.openGridView())}
				>
					{gridViewOpen ? 'Close grid view' : 'Open grid view'}
				</button>
			</div>

			<div className="metric-row">
				{METRICS.map(({ key, label, mod }) => (
					<div
						key={key}
						className={`metric-badge metric-badge--${mod}${activeMetric === key ? ' metric-badge--active' : ''}`}
						onClick={() => viewStore.toggleMetric(key)}
					>
						<span className="metric-badge__value">{loading ? '—' : metricCounts[key].toLocaleString()}</span>
						<span className="metric-badge__label">{label}</span>
					</div>
				))}
			</div>

			<div className="dashboard-body">
				<div className="chart-card">
					<div className="chart-card__breadcrumb">
						{sellerLabel} {' • '} {warehouseLabel}
					</div>

					{error && <p className="chart-card__error">{error}</p>}

					{loading ? (
						<div className="chart-card__loading">Loading...</div>
					) : (
						<BarChart data={chartData} selectedWarehouse={selectedWarehouseName} />
					)}

					<div className="status-cards">
						{statusKeys.map(key => (
							<StatusCard
								key={key}
								statusKey={key}
								value={totals && totals[key] != null ? totals[key] : 0}
								active={activeStatus === key}
								onClick={() => viewStore.setActiveStatus(key)}
								percentage={key === 'completed' ? completedPct : undefined}
								loading={completedLoading}
							/>
						))}
					</div>
				</div>

				{showWarehouses && (
					<ListPanel
						title="Warehouses"
						items={warehouseItems}
						selected={selectedWarehouse}
						onSelect={id => viewStore.setSelectedWarehouse(id)}
					/>
				)}

				{showSellers && (
					<ListPanel
						title="Sellers"
						items={sellerItems}
						selected={selectedSeller}
						onSelect={id => viewStore.setSelectedSeller(id)}
					/>
				)}

				<ListPanel
					title="Shipment Type"
					items={shipmentTypeItems}
					selected={selectedShipmentType}
					onSelect={id => viewStore.setSelectedShipmentType(id)}
				/>

				<div className="right-column">
					<ShipByDateChart
						data={shipByDateRows}
						selectedDate={selectedDate}
						onSelectDate={date => viewStore.setSelectedDate(date)}
					/>
					<CarrierCbmChart data={carrierCbm} includeLtl={selectedShipmentType === 'ltl'} />
				</div>
			</div>

			{gridViewOpen && <GridViewModal viewStore={viewStore} />}
		</section>
	);
});

export default DashboardTemplate;
